import styled from "styled-components"
import {
   mobilePortrait,
   mobile,
   tabletPortrait,
   tablet,
   smallScreen,
} from "../../Responsive"

export const Container = styled.div`
   height: 100vh;
   display: flex;
   align-items: center;
   justify-content: center;
   scroll-snap-align: center;
   position: relative;
   padding: 100px 20px 20px 20px;
   overflow: hidden;
   z-index: 0;

   ${tablet({ padding: "80px 10px 10px 10px" })}
   ${mobile({ padding: "60px 10px 10px 10px" })}
    ${mobilePortrait({ paddingTop: "40px" })}
    ${tabletPortrait({ flexDirection: "column" })}
`

export const Wrapper = styled.div`
   width: 34%;
   height: 100%;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   text-align: center;
   z-index: 3;

   ${tabletPortrait({ width: "100%", height: "34%" })}
`

export const Image = styled.img`
   width: 33%;
   height: 100%;
   object-fit: cover;
   object-position: center;
   border-radius: 10px;
   z-index: 1;

   ${tabletPortrait({ width: "100%", height: "33%" })}
`

export const Title = styled.h1`
   color: var(--darkGrey);

   @media screen and (max-width: ${smallScreen}) {
      font-size: var(--fontL);
   }
`

export const Text = styled.p`
   color: var(--darkGrey);
   margin-top: 1rem;
   width: 70%;
   max-width: 800px;

   ${mobilePortrait({ width: "95%", marginTop: "0rem" })}
`
